<template>
  <div class="xcard">
    <h3 class="text-center" style="margin-top:0"> Reporte de Marketing Centralizado por Sede </h3>
    <p class="text-center text-primary"> <small>Seleccione la sede y el rango de fechas</small> </p>
    <hr>

    <div class="row">
      <div class="col-sm-5">
        <Sedes :model="sede"/>
        <p> <small></small> </p>
        <Usuarios :model="sede" :idsede="sede.idsede.id" :multiple="true"/>
      </div>

      <div class="col-sm-7">
        <div class="col-sm-5" :class="{'has-error': validation.hasError('busqueda.fecha_ini')}">
          <Fecha :model="busqueda" :valueto="'fecha_ini'" :default="busqueda.fecha_ini"/>
          <small>Desde (28 dias atras)</small>
          <div class="error" v-if="validation.hasError('busqueda.fecha_ini')"> {{validation.firstError('busqueda.fecha_ini')}} </div>
        </div>
        <div class="col-sm-5" :class="{'has-error': validation.hasError('busqueda.fecha_fin')}">
          <Fecha :model="busqueda" :valueto="'fecha_fin'" :default="busqueda.fecha_fin"/>
          <small>Hasta (ahora)</small>
          <div class="error" v-if="validation.hasError('busqueda.fecha_fin')"> {{validation.firstError('busqueda.fecha_fin')}} </div>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-sm btn-primary" @click="clickBuscar()"> Buscar </button>
        </div>
      </div>
    </div>



    <Alertas ref="alertar" />
    <table class="table table-condensed table-striped table-bordered">
      <thead>
        <tr>
          <th style="min-width:80px"></th>
          <th class="text-center" colspan="12" style="background:#000000;color:white"> <small> TOTAL MES POR SEMANA </small></th>
        </tr>
        <tr>
          <th></th>
          <th class="text-center" colspan="3" style="background:#7F6000;color:white"> <small>  DIPLOMADOS  </small></th>
          <th class="text-center" colspan="3" style="background:#1155CC;color:white"> <small>  ESPECIALIDADES  </small></th>
          <th class="text-center" colspan="3" style="background:#674EA7;color:white"> <small>  MAESTRIAS  </small></th>
        </tr>
        <tr>
          <th></th>
          <th class="text-center" style="background:#BF9000;color:white"> <small> INSCRITOS </small></th>
          <th class="text-center" colspan="2" style="background:#BF9000;color:white"> <small> COBROS </small></th>
          <th class="text-center" style="background:#3C78D8;color:white"> <small> INSCRITOS </small></th>
          <th class="text-center" colspan="2" style="background:#3C78D8;color:white"> <small> COBROS </small></th>
          <th class="text-center" style="background:#8E7CC3;color:white"> <small> INSCRITOS </small></th>
          <th class="text-center" colspan="2" style="background:#8E7CC3;color:white"> <small> COBROS </small></th>
        </tr>
        <tr>
          <th></th>
          <th class="text-center" style="background:#F1C232;color:white"> <small> CANTIDAD </small></th>
          <th class="text-center" style="background:#F1C232;color:white"> <small> MATRICULA </small></th>
          <th class="text-center" style="background:#F1C232;color:white"> <small> COLEGIATURA </small></th>
          <th class="text-center" style="background:#6D9EEB;color:white"> <small> CANTIDAD </small></th>
          <th class="text-center" style="background:#6D9EEB;color:white"> <small> MATRICULA </small></th>
          <th class="text-center" style="background:#6D9EEB;color:white"> <small> COLEGIATURA </small></th>
          <th class="text-center" style="background:#B4A7D6;color:white"> <small> CANTIDAD </small></th>
          <th class="text-center" style="background:#B4A7D6;color:white"> <small> MATRICULA </small></th>
          <th class="text-center" style="background:#B4A7D6;color:white"> <small> COLEGIATURA </small></th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>Semana 1</td>
          <td style="background:#FFE599"> {{semanas[0].d}} </td>
          <td style="background:#FFE599"> {{semanas[0].mmd}} </td>
          <td style="background:#FFE599"> {{semanas[0].ccd}} </td>
          <td style="background:#A4C2F4"> {{semanas[0].e}} </td>
          <td style="background:#A4C2F4"> {{semanas[0].mme}} </td>
          <td style="background:#A4C2F4"> {{semanas[0].cce}} </td>
          <td style="background:#D9D2E9"> {{semanas[0].m}} </td>
          <td style="background:#D9D2E9"> {{semanas[0].mmm}} </td>
          <td style="background:#D9D2E9"> {{semanas[0].ccm}} </td>
        </tr>
        <tr>
          <td>Semana 2</td>
          <td style="background:#FFE599"> {{semanas[1].d}} </td>
          <td style="background:#FFE599"> {{semanas[1].mmd}} </td>
          <td style="background:#FFE599"> {{semanas[1].ccd}} </td>
          <td style="background:#A4C2F4"> {{semanas[1].e}} </td>
          <td style="background:#A4C2F4"> {{semanas[1].mme}} </td>
          <td style="background:#A4C2F4"> {{semanas[1].cce}} </td>
          <td style="background:#D9D2E9"> {{semanas[1].m}} </td>
          <td style="background:#D9D2E9"> {{semanas[1].mmm}} </td>
          <td style="background:#D9D2E9"> {{semanas[1].ccm}} </td>
        </tr>
        <tr>
          <td>Semana 3</td>
          <td style="background:#FFE599"> {{semanas[2].d}} </td>
          <td style="background:#FFE599"> {{semanas[2].mmd}} </td>
          <td style="background:#FFE599"> {{semanas[2].ccd}} </td>
          <td style="background:#A4C2F4"> {{semanas[2].e}} </td>
          <td style="background:#A4C2F4"> {{semanas[2].mme}} </td>
          <td style="background:#A4C2F4"> {{semanas[2].cce}} </td>
          <td style="background:#D9D2E9"> {{semanas[2].m}} </td>
          <td style="background:#D9D2E9"> {{semanas[2].mmm}} </td>
          <td style="background:#D9D2E9"> {{semanas[2].ccm}} </td>
        </tr>
        <tr>
          <td>Semana 4</td>
          <td style="background:#FFE599"> {{semanas[3].d}} </td>
          <td style="background:#FFE599"> {{semanas[3].mmd}} </td>
          <td style="background:#FFE599"> {{semanas[3].ccd}} </td>
          <td style="background:#A4C2F4"> {{semanas[3].e}} </td>
          <td style="background:#A4C2F4"> {{semanas[3].mme}} </td>
          <td style="background:#A4C2F4"> {{semanas[3].cce}} </td>
          <td style="background:#D9D2E9"> {{semanas[3].m}} </td>
          <td style="background:#D9D2E9"> {{semanas[3].mmm}} </td>
          <td style="background:#D9D2E9"> {{semanas[3].ccm}} </td>
        </tr>
        <tr>
          <td>Total Mes</td>
          <td style="background:#FFFF00"> {{semanas[4].t1}} </td>
          <td style="background:#FFFF00"> {{ roundx(semanas[4].t2) }} </td>
          <td style="background:#FFFF00"> {{ roundx(semanas[4].t3) }} </td>
          <td style="background:#FFFF00"> {{semanas[4].t4}} </td>
          <td style="background:#FFFF00"> {{semanas[4].t5}} </td>
          <td style="background:#FFFF00"> {{semanas[4].t6}} </td>
          <td style="background:#FFFF00"> {{semanas[4].t7}} </td>
          <td style="background:#FFFF00"> {{semanas[4].t8}} </td>
          <td style="background:#FFFF00"> {{semanas[4].t9}} </td>
        </tr>
      </tbody>
    </table>

    <div class="row">
      <div class="col-sm-2"></div>
      <div class="col-sm-4">
        <table class="table table-condensed table-striped table-bordered">
          <thead>
            <tr>
              <th rowspan="3"></th>
              <th colspan="2" class="text-center" style="background:#38761D;color:white">Cursos</th>
            </tr>
            <tr>
              <th class="text-center" style="background:#6AA84F;color:black">Inscritos</th>
              <th class="text-center" style="background:#6AA84F;color:black">Cobros</th>
            </tr>
            <tr>
              <th class="text-center" style="background:#93C47D;color:black">Cantidad</th>
              <th class="text-center" style="background:#93C47D;color:black">Inscripcion</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="background:#FFF2CC">Total</td>
              <td class="text-center" style="background:#B6D7A8;color:#980000"> {{semanas[5].ins}} </td>
              <td class="text-center" style="background:#B6D7A8;color:#980000"> {{semanas[5].c}} </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-sm-4">
        <table class="table table-condensed table-striped table-bordered">
          <thead>
            <tr>
              <th colspan="2" class="text-center" style="background:#F1C232;color:white">POSTGRADOS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="background:#FFE599;color:black">Matriculas</td>
              <td style="background:#FFE599;color:black"> {{semanas[5].matris}} </td>
            </tr>
            <tr>
              <td style="background:#FFE599;color:black">Colegiatura</td>
              <td style="background:#FFE599;color:black"> {{semanas[5].coles}} </td>
            </tr>
            <tr>
              <td style="background:#FFF2CC;color:black">TOTAL Bs.</td>
              <td class="text-center" style="background:#FFF2CC;color:#980000"> {{semanas[5].total}} </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>


    <div class="row">
      <div class="col-sm-1"></div>
      <div class="col-sm-10">
        <table class="table table-condensed table-striped table-bordered">
          <thead>
            <tr>
              <th colspan="4" class="text-center" style="background:#000000;color:white">RESUMEN MENSUAL DE SEDE</th>
            </tr>
            <tr>
              <th rowspan="2" style="background:#F1C232;color:black">Inscritos</th>
              <th style="background:#FFD966;color:black">total inscritos cursos</th>
              <th style="background:#FFE599;color:black"> {{semanas[5].ins}} </th>
              <th rowspan="2" style="background:#FFE599;color:black"> {{semanas[5].total2}} </th>
            </tr>
            <tr>
              <th style="background:#FFD966;color:black">total inscritos postgrados</th>
              <th style="background:#FFE599;color:black"> {{semanas[5].post}} </th>
            </tr>
            
          </thead>
          <tbody>
            <tr>
              <td rowspan="3" style="background:#38761D;color:white"> <b>Ingresos en bolivianos</b> </td>
              <td style="background:#6AA84F;color:black">Pagos cursos</td>
              <td colspan="2" style="background:#93C47D;color:black"> {{semanas[5].c}} </td>
            </tr>
            <tr>
              <td style="background:#6AA84F;color:black">Total matriculas</td>
              <td colspan="2" style="background:#93C47D;color:black"> {{semanas[5].matris}} </td>
            </tr>
            <tr>
              <td style="background:#6AA84F;color:black">total colegiatura</td>
              <td colspan="2" style="background:#93C47D;color:black"> {{semanas[5].coles}} </td>
            </tr>
            <tr>
              <td colspan="2" style="background:#000000;color:white">Total ingreso en bolivianos</td>
              <td colspan="2" style="background:#000000;color:white"> {{semanas[5].ingresos}} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import Sedes from '@/components/ASedes'
import Usuarios from '@/components/AUsuariosSemaforoMarketing.vue'
import Alertas from '@/components/AAlertas.vue'
import Fecha from '@/components/AFecha.vue'
import { Validator } from 'simple-vue-validator'
import {parseJsonError,error} from '@/components/Utils.js'
import gql from 'graphql-tag'

export default {
  data(){
    return{
      usuarios:[],
      sede: {idsede:{},idusuario:[]},
      busqueda: { fecha_ini: null,fecha_fin: null, },
      totales: {a:0,b:0,c:0,d:0,e:0,ee:0,eee:0,dd:0,aa:0,bb:0,cc:0,ddd:0,aaa:0,bbb:0,ccc:0},
      semanas:[ 
        {d:0,e:0,m:0,mmd:0,mme:0,mmm:0,ccd:0,cce:0,ccm:0 },
        {d:0,e:0,m:0,mmd:0,mme:0,mmm:0,ccd:0,cce:0,ccm:0 },
        {d:0,e:0,m:0,mmd:0,mme:0,mmm:0,ccd:0,cce:0,ccm:0 },
        {d:0,e:0,m:0,mmd:0,mme:0,mmm:0,ccd:0,cce:0,ccm:0 },
        {t1:0,t2:0,t3:0, t4:0,t5:0,t6:0, t7:0,t8:0,t9:0},
        {ins:0,c:0,matris:0,coles:0,total:0,post:0,total2:0,ingresos:0} //[5]
      ],
    }
  },
  components:{ Sedes,Fecha,Usuarios,Alertas },
  validators: {
    'busqueda.fecha_ini'(value){ return Validator.value(value).required(); },
    'busqueda.fecha_fin'(value){ return Validator.value(value).required(); },
  },
  watch:{
    'sede.idusuario': function( a ){
      window.console.log( a )

      this.usuarios =[]
      var vue = this;
      a.forEach( function(e){ 
        vue.usuarios.push( 
          {
            id:e.id,
            nombres:e.nombres,
            meta1:'-',
            meta2:'-',
            meta3:'-',
            meta4:'-',
            loading: false,
            ca:[],
            cb:[],
            cc:[],
            cd:[],
            tic:[],
            tip:[],
            nom: '-',
            cobros: '-',
            coles: '-',
            total: 0,
            totalm: 0,
            totalc: 0,
            tots:[
              {id:1,nom:'Total Inscripciones Cursos',t:0},
              {id:2,nom:'Total Inscripciones Progrs',t:0},
              {id:3,nom:'-',t:'-'},
              {id:4,nom:'Cursos',t:0},
              {id:5,nom:'Matriculas',t:0},
              {id:6,nom:'Colegiaturas',t:0},
              {id:7,nom:'Total Bs',t:0},
            ],
            totalcursos: 0,
            totalprogs: 0,
          } 
        ) 
      });
    },
  },

  
  methods:{
    clickBuscar(){
      if( !this.busqueda.fecha_ini || !this.busqueda.fecha_fin || this.sede.idusuario.length == 0 ){
        this.$notify( error( 'Faltan parametros','Complete los campos' ) )
        return;
      }
      this.semaforoistener();
    },

    semaforoistener(){
      var vue = this;
      this.usuarios.forEach( function(e){
        vue.getInscripciones( e )
      });
    },

    async getInscripciones( user ){
      var vue = this;
      var sql = gql`query{ getInscripcionesByUser(user:${user.id},fechas:{fecha_ini:"${this.busqueda.fecha_ini}",fecha_fin:"${this.busqueda.fecha_fin}"}){id,programa{postgrado{nombre,idcategoria,categoria{id,nombre}},inscripciones{fecha_registro,asesor{id},matricula{monto,saldo},cuotas_canceladas{monto,saldo} }}} }`
      window.console.log( ">>>>>>>>>>>>> ",sql );
      var d1 = new Date( this.busqueda.fecha_ini ); d1.setHours(0); d1.setDate( d1.getDate()+8 );
      var s1 = new Date(d1); d1.setHours(23); d1.setDate( d1.getDate()+7 );
      var s2 = new Date(d1); d1.setDate( d1.getDate()+7 );
      var s3 = new Date( d1 ); d1.setDate( d1.getDate()+7 );
      var s4 = new Date( d1 )
      window.console.log( s1,'\n',s2,'\n',s3,'\n',s4 );

      this.$refs.alertar.cargando();
      user.loading = true;

      vue.totales= {a:0,b:0,c:0,d:0,e:0,ee:0,eee:0,dd:0,aa:0,bb:0,cc:0,ddd:0,aaa:0,bbb:0,ccc:0};
      vue.semanas=[ 
        {d:0,e:0,m:0,mmd:0,mme:0,mmm:0,ccd:0,cce:0,ccm:0 },
        {d:0,e:0,m:0,mmd:0,mme:0,mmm:0,ccd:0,cce:0,ccm:0 },
        {d:0,e:0,m:0,mmd:0,mme:0,mmm:0,ccd:0,cce:0,ccm:0 },
        {d:0,e:0,m:0,mmd:0,mme:0,mmm:0,ccd:0,cce:0,ccm:0 },
        {t1:0,t2:0,t3:0, t4:0,t5:0,t6:0, t7:0,t8:0,t9:0},
        {ins:0,c:0,matris:0,coles:0,total:0,post:0,total2:0,ingresos:0} //[5]
      ];
      await this.$apollo.query({
        query: sql,
        }).then((data) => {
          var lista = data.data.getInscripcionesByUser;

          lista.forEach( function(e){
            var mio = e.programa.inscripciones.find( x => x.asesor.id == user.id)
            var cate = e.programa.postgrado.categoria.id;
            var registro = new Date( mio.fecha_registro );

            if( registro < s2 ) {
              if( cate == 1 ) { 
                vue.semanas[0].d += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[0].ccd += e.monto });
                if( mio.matricula ) vue.semanas[0].mmd += mio.matricula.monto
              }
              if( cate == 2 ) { 
                vue.semanas[0].e += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[0].cce += e.monto });
                if( mio.matricula ) vue.semanas[0].mme += mio.matricula.monto
              }
              if( cate == 3 ) { 
                vue.semanas[0].m += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[0].ccm += e.monto });
                if( mio.matricula ) vue.semanas[0].mmm += mio.matricula.monto
              }

            } else if( registro < s3 ) {
              if( cate == 1 ) { 
                vue.semanas[1].d += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[1].ccd += e.monto });
                if( mio.matricula ) vue.semanas[1].mmd += mio.matricula.monto
              }
              if( cate == 2 ) { 
                vue.semanas[1].e += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[1].cce += e.monto });
                if( mio.matricula ) vue.semanas[1].mme += mio.matricula.monto
              }
              if( cate == 3 ) { 
                vue.semanas[1].m += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[1].ccm += e.monto });
                if( mio.matricula ) vue.semanas[1].mmm += mio.matricula.monto
              }

            } else if( registro < s4 ) {
              if( cate == 1 ) { 
                vue.semanas[2].d += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[2].ccd += e.monto });
                if( mio.matricula ) vue.semanas[2].mmd += mio.matricula.monto
              }
              if( cate == 2 ) { 
                vue.semanas[2].e += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[2].cce += e.monto });
                if( mio.matricula ) vue.semanas[2].mme += mio.matricula.monto
              }
              if( cate == 3 ) { 
                vue.semanas[2].m += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[2].ccm += e.monto });
                if( mio.matricula ) vue.semanas[2].mmm += mio.matricula.monto
              }

            } else {
              if( cate == 1 ) { 
                vue.semanas[3].d += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[3].ccd += e.monto });
                if( mio.matricula ) vue.semanas[3].mmd += mio.matricula.monto
              }
              if( cate == 2 ) { 
                vue.semanas[3].e += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[3].cce += e.monto });
                if( mio.matricula ) vue.semanas[3].mme += mio.matricula.monto
              }
              if( cate == 3 ) { 
                vue.semanas[3].m += 1;
                mio.cuotas_canceladas.forEach( function(e){ vue.semanas[3].ccm += e.monto });
                if( mio.matricula ) vue.semanas[3].mmm += mio.matricula.monto
              }
            }

            // los cursos no entran por semanas
            if( cate == 5 ){
              vue.semanas[5].ins += 1
              mio.cuotas_canceladas.forEach( function(e){ vue.semanas[5].c += e.monto });
            }


            vue.semanas[4].t1 = vue.semanas[0].d + vue.semanas[1].d + vue.semanas[2].d + vue.semanas[3].d;
            vue.semanas[4].t2 = vue.semanas[0].mmd + vue.semanas[1].mmd + vue.semanas[2].mmd + vue.semanas[3].mmd;
            vue.semanas[4].t3 = vue.semanas[0].ccd + vue.semanas[1].ccd + vue.semanas[2].ccd + vue.semanas[3].ccd;
            vue.semanas[4].t4 = vue.semanas[0].e + vue.semanas[1].e + vue.semanas[2].e + vue.semanas[3].e;
            vue.semanas[4].t5 = vue.semanas[0].mme + vue.semanas[1].mme + vue.semanas[2].mme + vue.semanas[3].mme;
            vue.semanas[4].t6 = vue.semanas[0].cce + vue.semanas[1].cce + vue.semanas[2].cce + vue.semanas[3].cce;
            vue.semanas[4].t7 = vue.semanas[0].m + vue.semanas[1].m + vue.semanas[2].m + vue.semanas[3].m;
            vue.semanas[4].t8 = vue.semanas[0].mmm + vue.semanas[1].mmm + vue.semanas[2].mmm + vue.semanas[3].mmm;
            vue.semanas[4].t9 = vue.semanas[0].ccm + vue.semanas[1].ccm + vue.semanas[2].ccm + vue.semanas[3].ccm;
            vue.semanas[5].matris = vue.semanas[4].t2 + vue.semanas[4].t5 + vue.semanas[4].t8;
            vue.semanas[5].coles = vue.semanas[4].t3 + vue.semanas[4].t6 + vue.semanas[4].t9;
            vue.semanas[5].post = vue.semanas[4].t1 + vue.semanas[4].t4 + vue.semanas[4].t7;
            vue.semanas[5].total = vue.semanas[5].matris + vue.semanas[5].coles;
            vue.semanas[5].total2 = vue.semanas[5].post + vue.semanas[5].ins;
            vue.semanas[5].ingresos = vue.semanas[5].c + vue.semanas[5].matris + vue.semanas[5].coles;

            

            //window.console.log( ">>>>>>>>>>>>> ",window.stringifyObject(mio) );
            window.console.log( ">>>>>>>>>>>>> ",registro,e.programa.postgrado.categoria );
          })
          window.console.log( ">>>>>>>>>>>>> ",window.stringifyObject(vue.semanas) );

          this.$refs.alertar.reset();
        }).catch((error) => {
          vue.$refs.alertar.reset();
          window.console.error(error)
          this.$notify( parseJsonError( error,'getInscripcionesByUser' ) )
        })
    },
    roundx(num, decimales = 2) {
      var signo = (num >= 0 ? 1 : -1);
      num = num * signo;
      if (decimales === 0) return signo * Math.round(num);
      num = num.toString().split('e');
      num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
      num = num.toString().split('e');
      return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
    },

  },
  mounted(){
    var date = new Date();
    var date2 = new Date();
    date.setDate( date.getDate()-28 )
    var d1 = date.getDate()
    var m1 = date.getMonth()+1
    var d2 = date2.getDate()
    var m2 = date2.getMonth()+1
    if( d1 < 10 ) d1 = '0'+d1;
    if( m1 < 10 ) m1 = '0'+m1;
    if( d2 < 10 ) d2 = '0'+d2;
    if( m2 < 10 ) m2 = '0'+m2;

    var f1 = date.getFullYear()+'-'+m1+'-'+d1;
    var f2 = date2.getFullYear()+'-'+m2+'-'+d2;

    this.busqueda.fecha_ini = f1;
    this.busqueda.fecha_fin = f2;
  }
}
</script>